import config from 'config'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import Sticky from 'react-sticky-state'

import { isEmpty, checkNested } from 'srcReact/helpers/validator'
import { alertActions } from 'srcReact/Alert'
import { subscriptionActions } from 'srcReact/SubscriptionPage'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { commonActions, PopinComponent } from 'srcReact/components'
import { organizationActions } from 'srcReact/OrganizationPage'
import {
  PricingErrorMessage,
  PricingRestrictive,
  ChoosePlanRestriction,
  SuccessfulUpdatePopin,
  DowngradeConfirmationPopin,
  UpgradeConfirmationPopin,
  PaymentSourceRedirectionMessage
} from 'srcReact/components/popinsContent'
import PriceCard from 'srcReact/SubscriptionPage/components/PriceCard'
import PricingDetailsList from 'srcReact/SubscriptionPage/components/PricingDetailsList'
import Spinner from 'srcReact/components/common2/Spinner'
import { getDefaultNonPricing } from './PricingConfiguration/defaultPricingNonProfit'
import { getEUNonPricing } from './PricingConfiguration/euPricingNonProfit'
import { getCurrentLanguageFromCookie } from 'srcReact/helpers/utils'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { redirectToPage } from 'srcReact/helpers/history'

class PricingNonProfitPageContainer extends Component {
  constructor(props) {
    super(props)
    this.stickyEl = React.createRef()
    const { t } = props
    this.state = {
      redirect: false,
      countryCode: '',
      plans: [],
      isMonthly: props.isMonthly || false,
      selectedPlan: '',
      planChangeType: ''
    }
  }

  getPlans = (currency) => {
    const plans = currency?.code === 'EUR' ? getEUNonPricing(this.props.t) : getDefaultNonPricing(this.props.t)
    this.setState({ plans: plans })
  }

  componentDidMount() {
    const {
      getSubscription,
      current_organization,
      getWorkplaces,
      getPlanUpdateList,
      loggedIn,
      userLocation,
      getCurrency,
      currency,
      header
    } = this.props

    window.scrollTo(0, 0)
    this.getPlans(currency?.data)
    if (loggedIn && checkNested(current_organization, 'info', 'resourceKey')) {
      if (header?.subscription?.plan) {
        getSubscription(current_organization.info.resourceKey, 0)
        getWorkplaces(current_organization.info.resourceKey)
        getPlanUpdateList(current_organization.info.resourceKey)
      }
    }
    // this.handlePriceCardHeight()
    if (userLocation?.latitude && userLocation?.longitude && checkNested(current_organization, 'info', 'resourceKey')) {
      getCurrency(
        current_organization.info.resourceKey || 0,
        userLocation.longitude,
        userLocation.latitude,
        getCurrentLanguageFromCookie()
      )
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      isMobile,
      userLocation,
      getCurrency,
      current_organization,
      currency,
      header,
      getWorkplaces,
      getPlanUpdateList
    } = this.props
    const { countryCode } = this.state
    // if (isMobile !== prevProps.isMobile || countryCode !== prevState.countryCode) {
    //   console.log('insied asdasdasd')
    //   this.handlePriceCardHeight()
    // }
    // if (userLocation) {
    //   getCurrency(
    //     current_organization?.info?.resourceKey || 0,
    //     userLocation.longitude,
    //     userLocation.latitude,
    //     getCurrentLanguageFromCookie()
    //   )
    // }

    if (currency && prevProps.currency && currency.loading !== prevProps.currency.loading && currency.data) {
      this.setState({ countryCode: currency.data.code })
      this.getPlans(currency.data)
    }

    if (header?.subscription?.plan && header.subscription.plan !== prevProps.header?.subscription?.plan) {
      getWorkplaces(current_organization.info.resourceKey)
      getPlanUpdateList(current_organization.info.resourceKey)
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('pricing-plan-page')
  }

  handleChangeSwitch = () => {
    this.setState({ isMonthly: !this.state.isMonthly })
  }

  handleSwitchPricing = (isMonthlyValue) => {
    this.setState({ isMonthly: isMonthlyValue })
  }

  handlePriceCardHeight = () => {
    // const { isMobile } = this.props
    // const cards = document.querySelectorAll('.pricing-card--wrapper')
    // console.log('cards::', cards)
    // if (isMobile) {
    //   cards.forEach((card) => {
    //     card.style.height = `auto`
    //   })
    // } else {
    //   const maxHeight = [...cards].reduce((acc, card) => {
    //     console.log('card::', card)
    //     return card.clientHeight > acc ? card.clientHeight : acc
    //   }, 0)
    //   cards.forEach((card) => {
    //     card.style.height = `${maxHeight}px`
    //   })
    // }
  }

  handleRedirect = async (planName, planId) => {
    const {
      header,
      user,
      current_organization,
      subscription,
      workplace_list,
      updatePlan,
      subscriptionPlanListSuccess,
      subscriptionPlanListFailure
    } = this.props
    const totalInvites = header?.subscription
      ? header.subscription?.organization_member_quantity + header.subscription?.pending_invitation_quantity
      : 0
    const totalWorkplaces = workplace_list.items.length

    const planUpdate = this.getPlanUpdateDataByPlanName(planName)

    if (planUpdate && planUpdate.with_redirection === 1) {
      this.setState({ selectedPlan: planName })
      this.handleOpenPopin('upgrade-confirmation')
      return false
    }

    if (planUpdate && planUpdate.is_available === 1) {
      const planChangeType = this.upgradeOrDowngrade(planName)
      this.setState({ planChangeType, selectedPlan: planName })

      if (planChangeType === 'upgrade') {
        this.handleOpenPopin('upgrade-confirmation')
      } else {
        this.handleOpenPopin('downgrade-confirmation')
      }
      return false
    }

    if (planUpdate && planUpdate.is_available === 0) {
      this.setState({ selectedPlan: planName })
      this.handleOpenPopin('pricing-error-message')
      return false
    }

    if (header?.subscription?.plan && !subscriptionPlanListSuccess && !subscriptionPlanListFailure) {
      return false
    }

    if (header?.subscription?.organization_subscription) {
      this.handleOpenPopin('choose-plan-restriction')
      return false
    }

    if (planId === 'plan-1' && (totalWorkplaces > 1 || totalInvites > 25)) {
      this.handleOpenPopin('pricing-restrictive')
      return false
    }
    if (planId === 'plan-2' && totalWorkplaces > 2) {
      this.handleOpenPopin('pricing-restrictive')
      return false
    }
    if (planId === 'plan-3' && totalWorkplaces > 5) {
      this.handleOpenPopin('pricing-restrictive')
      return false
    }
    this.setState({ redirect: true })

    if (!isEmpty(user) && checkNested(current_organization, 'info', 'resourceKey')) {
      return this.props.redirectCheckout(current_organization.info.resourceKey, planName)
    }
    await localStorage.setItem('chosen_plan', planName)
    return (window.location = `${config.webUrl}/0/signup`)
  }

  handleOpenPopin = (name) => {
    const { openPopin } = this.props

    openPopin(name)
  }

  redirectContactUs = () => {
    window.location.href = isUserAuthorized() ? `${config.webUrl}/0/support` : `${config.webUrl}/contact-us`
  }

  redirectRegistration = () => {
    window.location.href = `${config.webUrl}/0/signup`
  }

  getPlanUpdateDataByPlanName = (planName) => {
    const { subscriptionPlanList } = this.props

    const plan = subscriptionPlanList.find((e) => e.id === planName)

    if (plan) {
      return plan
    }
  }

  upgradeOrDowngrade = (newPlanName) => {
    const { subscription, subscriptionPlanList, header } = this.props

    const currentPlan = header?.subscription?.plan?.id

    const currentPlanCategory = this.planCategory(currentPlan)
    const newPlanCategory = this.planCategory(newPlanName)

    if (currentPlanCategory === 'plan-free') {
      return 'upgrade'
    }

    if (newPlanCategory === 'plan-free') {
      return 'downgrade'
    }

    if (currentPlanCategory !== newPlanCategory) {
      return 'upgrade'
    }

    const subscriptionPlanListById = subscriptionPlanList.map((e) => e.id)
    const currentPlanIndex = subscriptionPlanListById.indexOf(currentPlan)
    const newPlanIndex = subscriptionPlanListById.indexOf(newPlanName)

    return currentPlanIndex - newPlanIndex < 0 ? 'upgrade' : 'downgrade'
  }

  planCategory = (plan) => {
    const profit = ['plan-essentials', 'plan-essentials-annual', 'plan-pro', 'plan-pro-annual']
    const nonProfit = [
      'plan-essentials-for-non-profit',
      'plan-essentials-annual-for-non-profit',
      'plan-pro-for-non-profit',
      'plan-pro-annual-for-non-profit'
    ]

    if (plan === 'plan-free') {
      return 'plan-free'
    }

    if (profit.includes(plan)) {
      return 'profit'
    }

    if (nonProfit.includes(plan)) {
      return 'non-profit'
    }
  }

  render() {
    const { current_organization, isNative, isMobile, loggedIn, t, subscription, updatePlan, currency, header } =
      this.props
    const { redirect, plans, isMonthly, planChangeType, selectedPlan, countryCode } = this.state

    return (
      <React.Fragment>
        {isNative ? (
          <PageContainer
            pageTitle={t('meta.pricingNonProfit.title')}
            pageDescription={t('meta.pricingNonProfit.description')}
            pageKeywords={t('meta.pricingNonProfit.keywords')}
            pageClassName='pricing-page-native'
            withFooter={false}>
            <div className='pricing-page-native__intro'>
              <h1 className='is-1 pricing-page-native__intro-title'>{t('billing.pricing.nativeVersion.title')}</h1>
              <p className='pricing-page-native__intro-text'>{t('billing.pricing.nativeVersion.text')}</p>
              <img
                className='pricing-page-native__intro-image'
                src={`${config.assetUrl}/images/native-pricing.jpg`}
                alt='Go to desktop'
              />
            </div>
          </PageContainer>
        ) : (
          <PageContainer
            pageTitle={t('meta.pricingNonProfit.title')}
            pageDescription={t('meta.pricingNonProfit.description')}
            pageKeywords={t('meta.pricingNonProfit.keywords')}
            pageClassName='pricing-page'
            withFooter={false}>
            {redirect || currency.loading ? (
              <div className='loader-container d-flex justify-content-center align-items-start pt-3'>
                <Spinner />
              </div>
            ) : (
              <div className='pricing-page--container'>
                <div className='pricing-page--intro'>
                  <div className='intro-content'>
                    <h1
                      className='is-1'
                      dangerouslySetInnerHTML={{ __html: t('billing.pricing.pageTitleNonProfit') }}
                    />
                    <p
                      className='with-discount'
                      dangerouslySetInnerHTML={{ __html: t('billing.pricing.pageTextNonProfitIntro') }}
                    />

                    {!isMobile && (
                      <div className='switch-wrapper'>
                        {!loggedIn && (
                          <button
                            type='button'
                            className='button is-primary'
                            onClick={() => this.redirectRegistration()}>
                            {t('billing.pricing.pageGetStartedNonProfitBtn')}
                          </button>
                        )}
                        <div className='switch-checkbox'>
                          <span className={isMonthly ? '' : 'active'}>{t('billing.pricing.yearly')}</span>
                          <label className='switch' htmlFor='switch-yearly'>
                            <input
                              type='checkbox'
                              tabIndex='-1'
                              autoFocus={false}
                              value={isMonthly}
                              onChange={() => this.handleChangeSwitch()}
                              id='switch-yearly'
                            />
                            <div className='slider' />
                          </label>
                          <span className={isMonthly ? 'active' : ''}>{t('billing.pricing.monthly')}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {isMobile && (
                  <Sticky>
                    <div className='pricing-sticky' ref={this.stickyEl}>
                      {!loggedIn && (
                        <button type='button' className='button is-primary' onClick={() => this.redirectRegistration()}>
                          {t('billing.pricing.pageGetStartedNonProfitBtn')}
                        </button>
                      )}
                      <div className='switch-pricing'>
                        <button
                          type='button'
                          className={`switch-pricing--btn ${isMonthly ? '' : 'active'}`}
                          onClick={() => this.handleSwitchPricing(false)}>
                          {t('billing.pricing.yearly')}
                        </button>
                        <button
                          type='button'
                          className={`switch-pricing--btn ${isMonthly ? 'active' : ''}`}
                          onClick={() => this.handleSwitchPricing(true)}>
                          {t('billing.pricing.monthly')}
                        </button>
                      </div>
                    </div>
                  </Sticky>
                )}
                <div className='pricing-page--wrapper pricing-page--wrapper-non-profit'>
                  {plans.map((plan) => (
                    <div key={plan.id} className='plan-wrapper'>
                      <PriceCard plan={plan} isMonthly={isMonthly} isNonProfit />
                      {!loggedIn && plan.id === 'plan-1' && (
                        <button
                          type='button'
                          className='button is-primary'
                          onClick={() => redirectToPage('/0/signup', isNative)}>
                          {t('billing.pricing.pageGetStartedNonProfitBtn')}
                        </button>
                      )}

                      {/* {plan.title === 'Enterprise' ? (
                        <button
                          type='button'
                          className={`button is-primary ${plan.color}`}
                          onClick={() => this.redirectContactUs()}>
                          {t('billing.pricing.contactUsBtn')}
                        </button>
                      ) : (
                        loggedIn &&
                        (isMonthly ? (
                          <button
                            type='button'
                            disabled={header?.subscription?.plan && header.subscription.plan.id === plan.nameMonthly}
                            className={`button is-primary ${plan.color}`}
                            onClick={() => this.handleRedirect(plan.nameMonthly, plan.id)}>
                            {header?.subscription?.plan && header.subscription.plan.id === plan.nameMonthly
                              ? t('billing.pricing.currentPlan')
                              : t('billing.pricing.choosePlanBtn')}
                          </button>
                        ) : (
                          <button
                            type='button'
                            disabled={header?.subscription?.plan && header.subscription.plan.id === plan.nameYearly}
                            className={`button is-primary ${plan.color}`}
                            onClick={() => this.handleRedirect(plan.nameYearly, plan.id)}>
                            {header?.subscription?.plan && header.subscription.plan.id === plan.nameYearly
                              ? t('billing.pricing.currentPlan')
                              : t('billing.pricing.choosePlanBtn')}
                          </button>
                        ))
                      )} */}
                    </div>
                  ))}
                  <p className='number-message'>
                    {!isMonthly && <span>{t('billing.pricing.availableForYearly')} - </span>}
                    {t('billing.pricing.numberMsg')}
                  </p>
                  <PricingDetailsList nonProfit countryCode={countryCode} />
                </div>

                <PopinComponent name='downgrade-confirmation'>
                  <DowngradeConfirmationPopin
                    updatePlan={() => updatePlan(current_organization.info.resourceKey, selectedPlan)}
                  />
                </PopinComponent>
                <PopinComponent name='upgrade-confirmation'>
                  <UpgradeConfirmationPopin
                    selectedPlan={this.getPlanUpdateDataByPlanName(selectedPlan)}
                    updatePlan={() => updatePlan(current_organization.info.resourceKey, selectedPlan)}
                  />
                </PopinComponent>
                <PopinComponent name='successful-update'>
                  <SuccessfulUpdatePopin
                    type={planChangeType}
                    subscription={header?.subscription}
                    selectedPlan={this.getPlanUpdateDataByPlanName(selectedPlan)}
                    update_infos={this.props.subscriptionPlan && this.props.subscriptionPlan.update_infos}
                  />
                </PopinComponent>
                <PopinComponent name='pricing-restrictive'>
                  <PricingRestrictive />
                </PopinComponent>
                <PopinComponent name='choose-plan-restriction'>
                  <ChoosePlanRestriction />
                </PopinComponent>
                {checkNested(current_organization, 'info', 'resourceKey') && (
                  <PopinComponent name='pricing-error-message'>
                    <PricingErrorMessage
                      organizationId={current_organization.info.resourceKey}
                      selectedPlan={this.getPlanUpdateDataByPlanName(selectedPlan)}
                    />
                  </PopinComponent>
                )}
                <PopinComponent name='payment-source-redirection-message'>
                  <PaymentSourceRedirectionMessage selectedPlan={this.getPlanUpdateDataByPlanName(selectedPlan)} />
                </PopinComponent>
              </div>
            )}
          </PageContainer>
        )}
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  const { alert, organization, common, login } = state
  const { current_organization, workplace_list, header } = organization
  const { isNative, isMobile, subscription, userLocation } = common
  const { user, loggedIn } = login
  const { subscriptionPlanList, subscriptionPlanListSuccess, subscriptionPlanListFailure, subscriptionPlan, currency } =
    state.subscription

  return {
    alert,
    loggedIn,
    user,
    current_organization,
    isMobile,
    subscription,
    isNative,
    workplace_list,
    subscriptionPlanList,
    subscriptionPlanListSuccess,
    subscriptionPlanListFailure,
    subscriptionPlan,
    userLocation,
    currency,
    header
  }
}

const actionCreators = {
  clearAlerts: alertActions.clear,
  redirectCheckout: subscriptionActions.redirectToSubscriptionCheckout,
  getWorkplaces: organizationActions.getWorkplaces,
  getSubscription: commonActions.getSubscription,
  getPlanUpdateList: subscriptionActions.getPlanUpdateList,
  updatePlan: subscriptionActions.updatePlan,
  openPopin: commonActions.openPopin,
  getUserIPAddress: commonActions.getUserIPAddress,
  getCurrency: subscriptionActions.getCurrency
}

const ExtendedComponent = withTranslation('common')(PricingNonProfitPageContainer)

const connectedPricingNonProfitPageContainer = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedPricingNonProfitPageContainer as PricingNonProfitPageContainer }
